var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOccupancyFewSeats = function SvgOccupancyFewSeats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.75 14-.169-1.518a3.352 3.352 0 0 0-6.662 0L.75 14z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.25,
    cy: 5.25,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 5.25,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.25 14-.169-1.518a3.352 3.352 0 0 0-6.662 0L8.25 14z"
  }))));
};
export default SvgOccupancyFewSeats;